import { observer } from "mobx-react";
import * as React from "react";
import { UitkSpacing } from "@egds/react-core/spacing";
import { UitkHeading } from "@egds/react-core/text";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import FlightBarChat from "components/flexComponents/Flights/components/FlightBarChart/FlightBarChart";
import { FareCalendar } from "typings/microserviceModels/flights-flex-module";
import { useLocalization } from "@shared-ui/localization-context";

export interface FlightBarChartViewProps {
  title: string;
  id: string;
  fareCalendar: FareCalendar[];
}

export const FlightBarChartView = observer((props: FlightBarChartViewProps) => {
  const { formatText } = useLocalization();

  return (
    <>
      <UitkSpacing margin={{ block: "two" }}>
        <UitkHeading tag="h2" size={5}>
          {props.title}
        </UitkHeading>
      </UitkSpacing>
      <Viewport>
        <ViewMedium>
          <FlightBarChat
            id={`flightBarChart-${props.id}`}
            fareCalendar={props.fareCalendar}
            isMobile={false}
            formatText={formatText}
          />
        </ViewMedium>
        <ViewSmall>
          <FlightBarChat
            id={`flightBarChart-${props.id}`}
            fareCalendar={props.fareCalendar}
            isMobile
            formatText={formatText}
          />
        </ViewSmall>
      </Viewport>
    </>
  );
});
